import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";

import { isEmpty, isEqual, map, size } from "lodash";
import Emitter from "@/utils/Emitter";
import { fetchMPSuppliers } from "@/store/modern/slices/memberSlice";
import seoConfig from "@/data/seo.config";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { useAuth } from "@/AuthProvider";
import SeoHelmet from "@/components/SeoHelmet";

import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import UpFilter from '@/modules/frontend/components/Market_Place/Suppliers/UpFilter';
import SideFilter from "@/modules/frontend/components/Market_Place/Suppliers/SideFilter";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";
import RegistrationPopup from "@/components/RegistrationPopup";
import SupplierInqPopup from "@/modules/frontend/components/Inquiry/SupplierInqPopup";

import no_data_found from "@/assets/images/svg/no_data_found.svg";
import supplierCommon from "@/assets/images/webp/marketplace-supplier-banner.webp";

import MobCommon from "@/assets/images/webp/mob-marketplace-supplier-banner.webp";
import { showSuccessMessage,buildPath } from "@/utils/common";
import roles from "@/constant/roles.config";
import { createplanReq } from "@/store/modern/slices/requestslice";
import MpSupplierCard from "@/modules/frontend/components/Market_Place/Suppliers/MpSupplierCard";
import { privateRoutePaths } from "@/routes/private.route.config";

const CATEGORY_MAP = {
  all: { img: supplierCommon, label: "All", category: "", mobImg: MobCommon, seoKey: "filterProducts" },
};

function MarketDetail() {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  const [searchParams, setsearchParams] = useSearchParams();
  const { user, isEndUser, isPreKYCUser, isDemoUser, isViewer } = useAuth();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const suppliers = useSelector((state) => state.member.mpSuppliers, shallowEqual);
  
  // const supplierMeta = useSelector((state) => state.member.mpSuppliers.data.metadata, shallowEqual);
  const supplierMeta = useSelector((state) => state.member.mpSuppliers.data, shallowEqual);
  
  const [filterObj, setFilterObj] = useState({
    business_type: "",
    supplier_country: "",
    search_txt: "",
    filterKeys: [],
    offset: 0,
    limit: 9
  });

  const [loader, setLoader] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [inqmodalshow, setInqModalShow] = useState(false);
  const [regmodalShow, setRegModalShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showContact, setShowContact] = useState(false);

  const bkImg = useRef("");
  const mobbkImg = useRef("");

  let pageCount = 0;

  if (supplierMeta) {
    pageCount = Math.ceil(supplierMeta.metadata.total / supplierMeta.metadata.limit);
    console.log("Page count ============ ", pageCount);
  }

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const handleRegistrationPopup = () => {
    let path = publicRoutePaths.REGISTRATION.path;
    navigate(path);
  }

  const handleUpgradePlanClick = async () => {
    if (user) {
      let data = {
        member_id: user.member_id
      }
      const response = await dispatch(createplanReq(data));
      if (response) {
        if (response.type === "upgradePlan/createRequest/fulfilled") {
          setRegModalShow(false);
           if (user.trade_mode_type !== 'SUPPLIER') {
            showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
           } else {
              setTimeout(() => {
                navigate(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`)
            }, 500);
           }
          
        }
      }
    }
  }

  const redirectFun = (e, id) => {
    e.preventDefault();
    setRegModalShow(false);


    setTimeout(() => {
      // navigate(publicRoutePaths.REGISTRATION.path);
      window.open(publicRoutePaths.REGISTRATION.path);
    }, 100);

  };

  const handleInqQuoteClick = (pdata) => {
    console.log("PData ============= ", pdata);
     let sdata = { ...pdata };
    // sdata.selected_product_id = pdata.id;
    sdata.industy_name = sdata.member_industry.industy_name;
    setSelectedSupplier(sdata);
    if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
      setInqModalShow(true);
    } else {
      setRegModalShow(true);
    }
  }

  const handlePageClick = async (event) => {
    let selctedIndex = event.selected + 1;
    let offsetVal = 0;
    if (selctedIndex === 1) {
      offsetVal = 0;
    } else {
      offsetVal = (selctedIndex - 1) * filterObj.limit;
    }

    const fObj = {
      ...filterObj,
      offset: offsetVal,
    };

    setFilterObj(fObj);

    await filterMPSuppliers(fObj);
    window.scrollTo(0, 0);
  }

  const filterMPSuppliers = (reqObj) => {
    setLoader(true);
    dispatch(fetchMPSuppliers(reqObj));
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }

  const setMPSupplierFilter = async (val) => {
    setFilterObj({ ...val });
    await filterMPSuppliers(val);
  }

  const handleInqClick = () => {
    setRegModalShow(false);
    setInqModalShow(true);
  }

  useEffect(() => {
    let c = "";
    if (isEmpty(c)) {
      c = "all";
    }
    const match = CATEGORY_MAP[c];
    bkImg.current = match?.img ?? "";
    mobbkImg.current = match?.mobImg ?? "";

    setFilterObj(prev => ({
      ...prev,
      offset: 0,
    }));

    let fObj = { ...filterObj };
    fObj.offset = 0;


    filterMPSuppliers(fObj);

  }, []);

  useEffect(() => {
    if (user) {
      if (isPreKYCUser || isEndUser) {
        if (user.trade_mode_type === "LOG_PTR") {
          setShowContact(false);
        } else {
          setShowContact(true);
        }
      }
    } else {
      setShowContact(true);
    }
  }, [user, isPreKYCUser, isEndUser]);

  useEffect(() => {
    Emitter.on("SET_MP_SUPPLIER_FILER", setMPSupplierFilter);
    return () => Emitter.off("SET_MP_SUPPLIER_FILER", setMPSupplierFilter);
    //Emitter.on("FILTER_PRODUCTS", filterProducts)
  }, []);

   useEffect(() => {
      console.log("regmodalShow:", regmodalShow);
      console.log("user:", user);
  
      if (
          regmodalShow &&
          user?.trade_mode_type === "SUPPLIER" &&
          user?.company_plan_name !== "Trial"
      ) {
          console.log("Supplier paid user - switching modal");
          if(isPreKYCUser) {
            setInqModalShow(false);
            setRegModalShow(true);
            
          } else {
            setRegModalShow(false);
            setInqModalShow(true);
          }
          
      }
  }, [regmodalShow, user, isPreKYCUser]);

  //  useEffect(() => {
    
  //         setInterval(() => {
  //           let u = localStorage.getItem("user");
  //           u = JSON.parse(u);
  //           if(!isEqual(u, user) && user?.company_plan_name !== "Trial" && parseInt(user?.current_step) === 4) {
  //             window.location.reload();
  //           }
  //         },1500);
  //      },[user]);
  useEffect(() => {
  const intervalId = setInterval(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("user"));

      if (
        stored &&
        !isEqual(stored, user) &&
        stored.company_plan_name !== "Trial" &&
        parseInt(stored.current_step) === 4
      ) {
        clearInterval(intervalId);
        window.location.reload();
      }
    } catch (e) {
      console.error("Invalid user in localStorage", e);
    }
  }, 1500);

  return () => clearInterval(intervalId); // cleanup
}, [user]);

  return (
    <section className="market-place-wrape market-detail">
      <SeoHelmet
        title={seoConfig.filterMPSuppliers.title}
        description={seoConfig.filterMPSuppliers.description}
        keywords={seoConfig.filterMPSuppliers.keywords}
        author={seoConfig.filterMPSuppliers.author}
      />

      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>

      {/* inner banner wrape START */}
      {loader && <ScreenLoaderHome />}
      <div className="inner-banner ipad-hide" style={{ background: `url(${bkImg.current})` }}>
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              {/* {!isEmpty(catRef.current) ? catRef.current : ""} */}
            </h2>
          </div>
        </div>
      </div>
      {/* inner banner wrape END */}

      {/* mobile inner banner wrape START */}
      <div className="marketplace-banner mobile-banner mobile-show">
        {/* Agriculture ipad banner here */}
        <img src={mobbkImg.current} alt="" className="mob-banner" />
      </div>
      {/* mobile inner banner wrape END */}

      <div className="bradcrumb-wrape">
        <div className="container">
          <ul>
            <li>
              <Link to={publicRoutePaths.HOME.path} title="Home">Home</Link>
            </li>
            <li>
              <Link to={publicRoutePaths.MARKET_PLACE.path} title="Market Place">Market Place</Link>
            </li>
            <li>
              {/* {!isEmpty(catRef.current) ? catRef.current : ""} */}
              Search Suppliers
            </li>
          </ul>
        </div>
      </div>

      <div className="inner-page-content-wrape market-place-page">

        <div className='container'>
          <div className='row'>
            <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-5'>
              <SideFilter filterObj={filterObj} />
            </div>
            <div className='col-xxl-9 col-xl-9 col-lg-9 col-md-7'>
              <UpFilter filterObj={filterObj} />

              <div className="row">
                {
                  suppliers && suppliers.status === true && map(suppliers.data.data, (suplr, key) => {
                    return (<div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12"> <MpSupplierCard key={`product_${suplr.id}`} data={suplr} showContact={(user && user.member_id == suplr.id) ? false : showContact} handleQuoteClick={handleInqQuoteClick} /></div>)
                  })
                }
              </div>

              {
                suppliers && suppliers.data && <div className={`${size(suppliers.data.data) > 0 ? "bottom-control-wrape" : ""}`}>
                    <div className="pagination-wrape">
                      {
                        pageCount > 1 && <ReactPaginate
                          nextLabel=""
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={2}
                          marginPagesDisplayed={2}
                          pageCount={pageCount}
                          previousLabel=""
                          pageClassName="number"
                          pageLinkClassName="number"
                          previousClassName="prev"
                          previousLinkClassName="prev"
                          nextClassName="next"
                          nextLinkClassName="next"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                          renderOnZeroPageCount={null}
                          forcePage={Math.floor((filterObj.offset || 0) / filterObj.limit)}
                        />
                      }

                    </div>
                    <div className="page-count-wrape">
                      {
                        supplierMeta && supplierMeta.metadata.total > 0 && `${(supplierMeta.metadata.offset) + 1}-${(supplierMeta.metadata.offset + supplierMeta.metadata.count)} of ${supplierMeta.metadata.total}`
                      }
                    </div>
                    {supplierMeta && supplierMeta.metadata.total === 0 &&
                      <div className="no-data"><img src={no_data_found} alt='No blog found.' /></div>
                    }
                  </div>
              }
              


            </div>
          </div>
        </div>
      </div>
      <ConsentManager />

      {smallmodalShow && (
        <PopUp
          title="Book Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}

      {
        inqmodalshow && (
          <PopUp
            title="Business Inquiry"
            smallmodalShow={inqmodalshow}
            setSmallModalShow={setInqModalShow}
            className="book-demo"
            size="lg"
          >
            <SupplierInqPopup data={selectedSupplier} setInqModalShow={setInqModalShow} from={!user ? "continue_buyer" : ""} />
          </PopUp>
        )
      }

      {
        regmodalShow && <RegistrationPopup
          title=""
          smallmodalShow={regmodalShow}
          setSmallModalShow={setRegModalShow}
          onSubmit={handleRegistrationPopup}
          okButtonLabel={'REGISTER NOW'
          }
        >
          {(() => {
            if (user && isPreKYCUser) {
              return (
                <>
                  <div className="new-pop">
                    <div className="img-wrape"></div>
                    <div className="detail-wrape">
                      <div className="inner">
                        <h5 className="registor-now">Upgrade Required!</h5>
                        <h6>Upgrade now to get more benefits!</h6>
                        <p className="registor-now-text">
                          Upgrade your plan to start connecting with sellers and raising inquiries.
                        </p>
                        {/* <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                          redirectFun(e, user.member_id)
                        }}>
                          Go to Profile
                        </Link> */}
                        <button type="button" className="btn secondry-btn" onClick={handleUpgradePlanClick}>
                          Upgrade Plan
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              );
            } else {
              return (

                <div className="new-pop">
                  <div className="img-wrape"></div>
                  <div className="detail-wrape">
                    <div className="inner">
                      <h5 className="registor-now">Grow With Us!</h5>
                      <p>
                        Select your role to get started:
                      </p>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon supplier"></span>
                        <span className="detail">
                          <h3>Supplier</h3>
                          <p>Sell and showcase your products</p>
                        </span>
                        {/* <p>
                          <span>Sell and showcase your products</span>
                        </p>Supplier */}

                      </Link>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon logistics"></span>
                        <span className="detail">
                          <h3>Logistic Partner</h3>
                          <p>Scaling Your Growth Through Reliable Logistics</p>
                        </span>

                      </Link>
                      <button type="button" className="popup-category-btn" onClick={handleInqClick}>
                        <span className="icon buyer"></span>
                        <span className="detail">
                          <h3>Buyer</h3>
                          <p>Discover and connect with suppliers</p>
                        </span>
                        {/* Buyer
                        <p>
                          <span>Discover and connect with suppliers</span>
                        </p> */}
                      </button>

                    </div>
                  </div>
                </div>
              );
            }
          })()}
        </RegistrationPopup>
      }

      <ToastContainer />
    </section>
  )
}

export default MarketDetail;
